export const ProtectedRoutes = {
    CompetitionLogicBook1: '/pt/competitions/logic-book-1/:code',
};
